import React from "react";
import { currencyFormat } from "simple-currency-format";
import dayjs from "dayjs";
import { Text, Box, Flex, Image, ActionIcon, Tooltip, Group } from "@mantine/core";

import Banregio from "../../assets/banks/banregio.webp";
import Azteca from "../../assets/banks/azteca.webp";
import Bbva from "../../assets/banks/bbva2.png";
import Hsbc from "../../assets/banks/hsbc.png";
import MercadoPago from "../../assets/banks/mercado-pago.webp";
import Santander from "../../assets/banks/santander-logo-1.webp";
import Efectivo from "../../assets/banks/efectivo.png";
import Spin from "../../assets/banks/spin.png";
import { HiTrash } from "react-icons/hi";
import { useAuthStore } from "../../store/useAuthStore";

const bankImages = {
  "mercado pago": MercadoPago,
  "bbva": Bbva,
  "santander": Santander,
  "hsbc": Hsbc,
  "banregio": Banregio,
  "azteca": Azteca,
  "efectivo": Efectivo,
  "spin": Spin,
};

const Record = ({ item, rollBackRenovation }) =>
{
  const { username } = useAuthStore();
  
  const renderBankImage = (bankName) => {
    const normalizedName = bankName?.toLowerCase();
    const imageSrc = bankImages[normalizedName];

    return (
      <Box className="w-12 h-12 rounded-full border-2 flex flex-col items-center justify-center p-1 bg-gray-100">
        <Image
          src={ imageSrc }
          alt={ bankName }
          title={ bankName }
          className="w-auto h-auto"
        />
      </Box>
    );
  };

  const renderRollBackAction = () => (
    (username === 'cobas' || username === 'jvaldes') ? (
      <Box className="flex items-center">
        <Tooltip label="Revertir renovación">
          <ActionIcon size="lg" variant="subtle" color="red" onClick={ () => rollBackRenovation(item) } padding="sm">
            <HiTrash size="20" />
          </ActionIcon>
        </Tooltip>
      </Box>
    ) : null
  )

  return (
    <Box 
      p="xs" 
      style={{ 
        borderBottom: '1px solid var(--mantine-color-gray-1)',
        backgroundColor: 'var(--mantine-color-white)',
        transition: 'background-color 0.2s ease',
      }}
      className="hover:bg-gray-50"
    >
      <Flex justify="space-between" align="center" gap="md">
        {/* Left: ID & User */}
        <Group gap="xs" style={{ flex: 1 }}>
          <Box 
            px={6} py={2} 
            style={{ 
              backgroundColor: 'var(--mantine-color-gray-1)', 
              borderRadius: '2px',
              fontFamily: 'var(--mantine-font-family-monospace)',
              fontSize: '11px',
              fontWeight: 700
            }}
          >
            { item.num_account }
          </Box>
          <Box>
            <Text size="sm" fw={700} style={{ lineHeight: 1.2 }}>{ item.full_name }</Text>
            <Text size="10px" c="dimmed" tt="uppercase" fw={700}>{ item.type_contract }</Text>
          </Box>
        </Group>

        {/* Center: Bank Info */}
        <Group gap="xs" style={{ width: '140px' }}>
          { renderBankImage(item.type_bank_name) }
          <Text size="xs" fw={600} truncate>{ item.type_bank_name }</Text>
        </Group>

        {/* Right: Date & Amount */}
        <Flex align="center" gap="xl" style={{ minWidth: '200px' }} justify="flex-end">
          <Box style={{ textAlign: 'right' }}>
            <Text size="11px" fw={700} c="dimmed">
              { dayjs(item?.created_date).format("DD/MM/YY HH:mm") }
            </Text>
          </Box>
          
          <Box style={{ width: '90px', textAlign: 'right' }}>
            <Text 
              size="sm" 
              fw={800} 
              style={{ fontFamily: 'var(--mantine-font-family-monospace)' }}
            >
              { currencyFormat(item.amount, "es-MX", "MXN", 2) }
            </Text>
          </Box>

          <Box>
            { renderRollBackAction() }
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
}

export default Record;
